export default __webpack_public_path__ + "static/media/edit.9d5342f1.svg";